import React, { useState } from 'react';
import ReactDOM from "react-dom";
import JobOrderInvoiceDataTable from "../../datatables/JobOrderInvoiceDataTable";
import JobOrderInvoiceCreateEditPage from "../JobOrderInvoiceCreateEditPage";

export const INVOICE_PAGES = {
    INDEX:  'index',
    CREATE: 'create',
    EDIT:   'edit',
}

const JobOrderInvoicePage = (props) => {
    const {
        jobId       = null,
        orderId     = null,
        invoiceId   = null,
        page        = INVOICE_PAGES.INDEX,
        parentId    = "",
    } = props;


    const [currentPage, setCurrentPage]         = useState(page);
    const [selectedInvoice, setSelectedInvoice] = useState(!!invoiceId ? {id: invoiceId} : null);

    const handleChangePage = (page, invoice) => {
        switch (page) {
            case INVOICE_PAGES.INDEX:
                window.history.pushState({}, '', route('job.order.invoice.index', {job: jobId, order: orderId}).toString());
                break;
            case INVOICE_PAGES.CREATE:
                window.history.pushState({}, '', route('job.order.invoice.create', {job: jobId, order: orderId}).toString());
                break;
            case INVOICE_PAGES.EDIT:
                window.history.pushState({}, '', route('job.order.invoice.edit', {job: jobId, order: orderId, invoice: invoice.id}).toString());
                break;
        }

        setCurrentPage(page);
        setSelectedInvoice(invoice);
    }

    switch (currentPage) {
        case INVOICE_PAGES.EDIT:
            return (
                <JobOrderInvoiceCreateEditPage
                    jobId={jobId}
                    orderId={orderId}
                    invoiceId={!!selectedInvoice && !!selectedInvoice.id ? selectedInvoice.id : null}
                    onChangePage={(page, invoice) => handleChangePage(page, invoice)}
                    parentId={parentId}
                />
            );
        case INVOICE_PAGES.CREATE:
            return (
                <JobOrderInvoiceCreateEditPage
                    jobId={jobId}
                    orderId={orderId}
                    invoiceId={null}
                    onChangePage={(page, invoice) => handleChangePage(page, invoice)}
                    parentId={parentId}
                />
            );
        case INVOICE_PAGES.INDEX:
        default:
            return (
                <JobOrderInvoiceDataTable
                    jobId={jobId}
                    orderId={orderId}
                    onChangePage={(page, invoice) => handleChangePage(page, invoice)}
                    parentId={parentId}
                />
            );
    }
}

export default JobOrderInvoicePage;

const target = document.getElementById('job-order-invoice-page');
if (target) {
    const {
        jobId       = null,
        orderId     = null,
        invoiceId   = null,
        page        = INVOICE_PAGES.INDEX,
        parentId    = 'job-order-invoice-page'
    } = target.dataset;

    ReactDOM.render(
        <JobOrderInvoicePage
            jobId={jobId}
            orderId={orderId}
            invoiceId={invoiceId}
            page={page}
            parentId={parentId}
        />
        , target);
}

